import i18n from '@/i18n'
import { LISTING_KINDS } from '@/config/listing-kind'
import type { ListingKind } from '@/types/listing'

// 不放进 listing-kind.ts：useLookup 引 listing-kind，apiBarrelGraph 限制它的 import 图，不能带上 i18n。
/**
 * kind 的显示名。用全局 i18n：这个函数也在 hook 之外调用，语言切换后下次渲染跟着变。
 * 不认识的值原样显示，不留空。
 */
export function listingKindLabel(kind?: string | null): string {
  if (!kind) return '—'
  return (LISTING_KINDS as readonly string[]).includes(kind) ? i18n.t(`listings:kinds.${kind}`) : kind
}

/** 筛选用的选项。label 是 getter：模块加载时语言还没定 */
export const LISTING_KIND_OPTIONS: { value: ListingKind; label: string }[] = LISTING_KINDS.map((value) => ({
  value,
  get label() { return listingKindLabel(value) },
}))
